// Marketing games library — the aspirational catalog shown on the landing page.
// Cover art is self-hosted under /games (Steam capsule art). Minecraft isn't on
// Steam, so it renders as a styled tile (img: null).
export interface MarketingGame {
  name: string;
  mono: string; // fallback monogram when there's no cover image
  tag: string; // category
  img: string | null; // /games/<key>.jpg
}

export const GAME_LIBRARY: MarketingGame[] = [
  { name: "Minecraft", mono: "MC", tag: "Sandbox", img: null },
  { name: "Valheim", mono: "VH", tag: "Survival", img: "/games/valheim.jpg" },
  { name: "Rust", mono: "RU", tag: "Survival PvP", img: "/games/rust.jpg" },
  { name: "Palworld", mono: "PW", tag: "Survival", img: "/games/palworld.jpg" },
  { name: "ARK: Survival Ascended", mono: "AR", tag: "Survival", img: "/games/ark.jpg" },
  { name: "Counter-Strike 2", mono: "CS", tag: "Shooter", img: "/games/cs2.jpg" },
  { name: "Terraria", mono: "TR", tag: "Sandbox", img: "/games/terraria.jpg" },
  { name: "Project Zomboid", mono: "PZ", tag: "Survival", img: "/games/project-zomboid.jpg" },
  { name: "Satisfactory", mono: "SF", tag: "Co-op", img: "/games/satisfactory.jpg" },
  { name: "7 Days to Die", mono: "7D", tag: "Survival", img: "/games/seven-days.jpg" },
  { name: "Garry's Mod", mono: "GM", tag: "Sandbox", img: "/games/garrys-mod.jpg" },
  { name: "V Rising", mono: "VR", tag: "Survival", img: "/games/v-rising.jpg" },
  { name: "Enshrouded", mono: "EN", tag: "Survival", img: "/games/enshrouded.jpg" },
  { name: "Sons of the Forest", mono: "SF", tag: "Co-op horror", img: "/games/sons-of-the-forest.jpg" },
  { name: "Factorio", mono: "FA", tag: "Co-op", img: "/games/factorio.jpg" },
  { name: "Conan Exiles", mono: "CE", tag: "Survival", img: "/games/conan-exiles.jpg" },
  { name: "DayZ", mono: "DZ", tag: "Survival PvP", img: "/games/dayz.jpg" },
  { name: "Core Keeper", mono: "CK", tag: "Sandbox", img: "/games/core-keeper.jpg" },
  { name: "Don't Starve Together", mono: "DS", tag: "Co-op", img: "/games/dont-starve.jpg" },
  { name: "Unturned", mono: "UN", tag: "Survival", img: "/games/unturned.jpg" },
  { name: "The Forest", mono: "TF", tag: "Co-op horror", img: "/games/the-forest.jpg" },
  { name: "Squad", mono: "SQ", tag: "Shooter", img: "/games/squad.jpg" },
];

export const GAME_MARQUEE = GAME_LIBRARY.map((g) => g.name);
